import { useBadgeHistoryTable } from '../../../../ui/features/badge-management/hooks/useBadgeHistoryTable';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { showAlertDialog } from '@juvare/common-web-ui/DialogHelper';
import React from 'react';
import { useAccountBadgeHistoryTableColumns } from './useAccountBadgeHistoryTableColumns';
export const useAccountBadgeHistoryOpenAction = (params) => {
    const { t } = useBadgingTranslation();
    const { accountBadge } = params;
    const handleAccountBadgeHistoryOpen = () => {
        if (!accountBadge) {
            return;
        }
        showAlertDialog({
            title: t('badges.badgeDetails.accountBadgeTable.menuItems.history.modalTitle'),
            closeLabel: t('common.close'),
            content: React.createElement(AccountBadgeHistoryTable, { accountBadge: accountBadge }),
            maxWidth: 'md',
        });
    };
    return { handleAccountBadgeHistoryOpen };
};
const AccountBadgeHistoryTable = ({ accountBadge }) => {
    const { dataTableProps } = useBadgeHistoryTable({
        badgeId: accountBadge.columns.badgeId,
        accountBadgeId: accountBadge.id,
    });
    const columns = useAccountBadgeHistoryTableColumns();
    return React.createElement(DataTable, Object.assign({}, dataTableProps, { columns: columns }));
};
